var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0287 14.828C20.6958 14.7619 20.352 14.7266 20 14.7266C17.0922 14.7266 14.7266 17.0922 14.7266 20C14.7266 22.9078 17.0922 25.2734 20 25.2734C22.9078 25.2734 25.2734 22.9078 25.2734 20C25.2734 19.648 25.2381 19.3042 25.172 18.9713L22.0716 22.0716C21.5182 22.625 20.7825 22.9297 20 22.9297C19.2175 22.9297 18.4818 22.625 17.9284 22.0716C17.375 21.5182 17.0703 20.7825 17.0703 20C17.0703 19.2175 17.375 18.4818 17.9284 17.9284L21.0287 14.828Z",
    fill: "url(#paint0_linear_28128_14357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1753 13.1118L33.0742 15.213C32.8638 15.4233 32.6268 15.5977 32.371 15.733C32.8338 17.0715 33.0861 18.5071 33.0861 20.0007C33.0861 27.2163 27.2158 33.0866 20.0002 33.0866C12.7845 33.0866 6.91423 27.2163 6.91423 20.0007C6.91423 12.785 12.7845 6.91471 20.0002 6.91471C21.4943 6.91471 22.9306 7.16725 24.2693 7.63035C24.4049 7.37426 24.5781 7.13622 24.7881 6.92641L26.889 4.82553C24.7881 3.86804 22.4556 3.33398 20.0002 3.33398C10.81 3.33398 3.3335 10.8105 3.3335 20.0007C3.3335 29.1908 10.81 36.6673 20.0002 36.6673C29.1903 36.6673 36.6668 29.1908 36.6668 20.0007C36.6668 17.5453 36.1328 15.2127 35.1753 13.1118Z",
    fill: "url(#paint1_linear_28128_14357)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1478 11.7089L23.9698 9.5991C22.7362 9.12633 21.398 8.86719 20 8.86719C13.8614 8.86719 8.86719 13.8614 8.86719 20C8.86719 26.1386 13.8614 31.1328 20 31.1328C26.1386 31.1328 31.1328 26.1386 31.1328 20C31.1328 18.602 30.8737 17.2638 30.4009 16.0302L28.2911 15.8522L26.7426 17.4004C27.0549 18.2076 27.2266 19.084 27.2266 20C27.2266 23.9848 23.9848 27.2266 20 27.2266C16.0152 27.2266 12.7734 23.9848 12.7734 20C12.7734 16.0152 16.0152 12.7734 20 12.7734C20.916 12.7734 21.7924 12.9451 22.5996 13.2574L24.1478 11.7089Z",
    fill: "url(#paint2_linear_28128_14357)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8861 9.0789L26.1704 12.448L19.3095 19.3089C18.9281 19.6901 18.9281 20.3086 19.3095 20.6898C19.5 20.8806 19.75 20.9759 20 20.9759C20.25 20.9759 20.5 20.8806 20.6905 20.6898L27.5513 13.829L30.9205 14.113C30.9479 14.1153 30.9751 14.1166 31.0026 14.1166C31.2605 14.1166 31.5092 14.0144 31.6931 13.8305L35.8361 9.68722C36.1049 9.41867 36.1934 9.01838 36.0629 8.66132C35.9322 8.30427 35.6064 8.05555 35.2278 8.02376L32.2284 7.77072L31.9756 4.7716C31.9436 4.39267 31.6948 4.0669 31.338 3.93644C30.981 3.80572 30.5807 3.89447 30.3119 4.16303L26.1689 8.3063C25.9654 8.50975 25.8619 8.79229 25.8861 9.0789Z",
    fill: "url(#paint3_linear_28128_14357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28128_14357",
    x1: 14.7266,
    y1: 20,
    x2: 25.2734,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28128_14357",
    x1: 3.3335,
    y1: 20.0007,
    x2: 36.6668,
    y2: 20.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28128_14357",
    x1: 8.86719,
    y1: 20,
    x2: 31.1328,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28128_14357",
    x1: 19.0234,
    y1: 12.4264,
    x2: 36.1223,
    y2: 12.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal2);
export default __webpack_public_path__ + "static/media/goal_2.d6dbbf0aea4f64d0cf7a5a249ee0e393.svg";
export { ForwardRef as ReactComponent };